import React, {useState} from 'react';
import {
  stickedLeft,
  tableColWidths,
  TableHeader,
  ToggleButton,
  TxtTitlesTable
} from "./styling/participation";
import InstrumentsMusiciansTableBody from "./InstrumentsMusiciansTableBody";
import {instrumentGroups} from "../../../../../../helpers/tools";

const getGroupForInstrument = (instrument) => {
  return Object.entries(instrumentGroups).find(([_, list]) => list.includes(instrument))?.[0];
};


// komponent wyswietla naglowki tabeli z danymi o projektach - przekazuje funkcje wyswietlania tabeli z instrumentami
const ParticipationTableGenerator = ({users, projects, t, dispatch, ChangeDBHandler, handleCopyEmail}) => {
  const [visibleColumns, setVisibleColumns] = useState({ telephone: true, mail: true });
  const [visibleGroups, setVisibleGroups] = useState({ Strings: true, Harmony: true, Vocal: true });
  const [hideEmpty, setHideEmpty] = useState(false);

  const toggleColumn = (columnKey) => {
    setVisibleColumns((prevState) => ({ ...prevState, [columnKey]: !prevState[columnKey] }));
  };

  const toggleGroup = (groupName) => {
    setVisibleGroups((prevState) => ({ ...prevState, [groupName]: !prevState[groupName] }));
  };

  const isInstrumentVisible = (instrument) => {
    const group = getGroupForInstrument(instrument);
    if (!group) return true;
    return visibleGroups[group];
  };

  const toggleHideEmpty = () => setHideEmpty((prev) => !prev);

  //create left sticky columns
  const getStickyLeft = (columns) => {
    return `calc(${columns.map((col) => {
      if (visibleColumns.hasOwnProperty(col)) {
        return visibleColumns[col] === false ? '80px' : tableColWidths[col];
      }
      return tableColWidths[col]; // fallback for col like 'index', 'name'
    }).join(' + ')})`;
  };

  const projectList = projects.map(p => ({
    id: p.project_current_id,
    name: p.name,
    date: p.first_date,
    direction: p.direction,
    totals: p.total
  }));

  return (
    <>
      <div style={{ marginBottom: "10px", display: "flex", flexWrap: "wrap", gap: "8px" }}>
        {Object.keys(visibleGroups).map(group => (
          <ToggleButton
            key={group}
            onClick={() => toggleGroup(group)}
            className={`btn btn-sm btn-outline-primary ${visibleGroups[group] ? "active" : ""}`}
          >
            {group}
          </ToggleButton>
        ))}
        <ToggleButton
          onClick={toggleHideEmpty}
          className={`btn btn-sm btn-outline-secondary ${hideEmpty ? "active" : ""}`}
        >
          {hideEmpty ? "Show all" : "Hide empty"}
        </ToggleButton>
      </div>

      <div style={{ maxHeight: '680px', overflowY: 'auto' }}>
        <table className="table" style={{ tableLayout: 'fixed' }}>
          <thead style={{ position: 'sticky', top: 0, backgroundColor: '#efe9e3', zIndex: 5 }}>
            <tr>
              <th scope="col" style={{ width: tableColWidths.index, ...stickedLeft, left: '0', backgroundColor:'#efe9e3', zIndex:10 }}>#</th>
              <th scope="col" style={{ width: tableColWidths.name, ...stickedLeft, left: tableColWidths.index, backgroundColor:'#efe9e3', zIndex:10}}>
                {t("project.availabilities.table_mus_title")}
              </th>
              <TableHeader
                  style={{
                    width: tableColWidths.telephone,
                    ...stickedLeft,
                    left: getStickyLeft(['index', 'name']),
                    backgroundColor: '#efe9e3', zIndex:10
                  }}
                  scope="col"
                  onClick={() => toggleColumn("telephone")}
                  isHidden={!visibleColumns.telephone}
              >
                {t("project.availabilities.table_mus_phone_title")}
              </TableHeader>
              <TableHeader 
                style={{ width: tableColWidths.email, ...stickedLeft, left: getStickyLeft(['index', 'name', 'telephone']), 
                backgroundColor: '#efe9e3', zIndex: 10 }} 
                scope="col" onClick={() => toggleColumn("mail")} isHidden={!visibleColumns.mail}>
                {t("project.availabilities.table_mus_email_title")}
              </TableHeader>
              {projectList.map((project, index) => (
                <th style={{ width: tableColWidths.project, zIndex: 2 }} scope="col" key={`project_${index}`}>
                  <div style={{ textAlign: "center" }}>
                    <TxtTitlesTable>ID: {project.id}</TxtTitlesTable>
                    <div className="mb-1">{project.name}</div>
                    <TxtTitlesTable>Start</TxtTitlesTable>
                    <div className="mb-1">{project.date || "-"}</div>
                    <TxtTitlesTable>Direction</TxtTitlesTable>
                    <div className="mb-1">{project.direction || "-"}</div>
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            <InstrumentsMusiciansTableBody
                users={users}
                projectList={projectList}
                dispatch={dispatch}
                ChangeDBHandler={ChangeDBHandler}
                handleCopyEmail={handleCopyEmail}
                isInstrumentVisible={isInstrumentVisible}
                hideEmpty={hideEmpty}
                getStickyLeft={getStickyLeft}
                visibleColumns={visibleColumns}
                t={t}
            />
          </tbody>
        </table>
      </div>
    </>
  );
};

export default ParticipationTableGenerator;